import { useQuery } from '@tanstack/react-query';

import { createSubscription } from '@features/Stripe/api';
import type { TpStripeCreateSubscription } from '@features/Stripe/types';
import { useGetAppName } from 'src/utils/hooks';

export const useCreateSubscription = ({
  priceId,
  userId,
  currency,
  email,
  token,
  introOfferId,
  introOfferDuration,
  cancelAtPeriodEnd,
  campaign,
}: TpStripeCreateSubscription) => {
  const app = useGetAppName();
  return useQuery({
    queryKey: [
      'create-stripe-subscription',
      priceId,
      currency,
      introOfferId,
      introOfferDuration,
      cancelAtPeriodEnd,
      userId,
      app,
    ],
    queryFn: () =>
      createSubscription({
        priceId,
        userId,
        currency,
        email,
        app,
        token,
        introOfferId,
        introOfferDuration,
        cancelAtPeriodEnd,
        campaign,
      }),
    enabled: !!priceId && !!userId && !!email,
    gcTime: 10 * 1000 * 60, // 10 minutes
    staleTime: 10 * 1000 * 60, // Consider data fresh for 10 minutes
    retry: 0, // No retries on failure
  });
};
